import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Truck, Users, AlertTriangle } from 'lucide-react';
export function FailedAlternatives() {
  const alternatives = [{
    icon: <Building2 size={32} data-id="element-66" />,
    title: 'The National Franchise',
    desc: "You called a big national company and the quote made your jaw drop. Plus, they won't touch demolition or heavy specialty items."
  }, {
    icon: <Truck size={32} data-id="element-67" />,
    title: 'The Dumpster Rental',
    desc: 'You rented a dumpster and realized — wait, I still have to do ALL the heavy lifting, loading, and property damage risk myself.'
  }, {
    icon: <Users size={32} data-id="element-68" />,
    title: 'The Buddy With A Truck',
    desc: "You asked a friend, and he flaked. Or you've just been putting it off, telling yourself you'll rent a truck 'next weekend.'"
  }];
  return <section className="py-20 bg-white border-y border-gray-200" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-71">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-72">
            HERE'S WHAT HAPPENS WHEN YOU{' '}
            <span className="text-[#C8102E]" data-id="element-73">KEEP WAITING</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600" data-id="element-74">
            Every week that pile sits there, it gets heavier — not just
            physically, but mentally. The junk isn't just in your space.{' '}
            <strong className="text-gray-900" data-id="element-75">It's blocking your life.</strong>
          </motion.p>
        </div>

        <div className="mb-20" data-id="element-76">
          <h3 className="text-2xl font-bold text-center mb-10 text-gray-800 uppercase tracking-wide" data-id="element-77">
            You've Probably Already Tried to Handle This:
          </h3>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-78">
            {alternatives.map((alt, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#F9F9F9] p-8 rounded-lg border border-gray-200 relative overflow-hidden group hover:border-[#C8102E] transition-colors" data-id="element-79">
                <div className="text-gray-400 mb-6 group-hover:text-[#C8102E] transition-colors" data-id="element-80">
                  {alt.icon}
                </div>
                <h4 className="text-xl font-bold mb-3 text-[#1A1A1A]" data-id="element-81">
                  {alt.title}
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-82">{alt.desc}</p>
                <div className="absolute top-4 right-4 text-gray-300" data-id="element-83">
                  <AlertTriangle size={24} data-id="element-84" />
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1A1A1A] text-white p-10 md:p-16 rounded-xl text-center shadow-2xl" data-id="element-85">
          <h3 className="text-3xl md:text-4xl font-bold mb-6 text-[#C8102E]" data-id="element-86">
            NONE OF THOSE SOLUTIONS ACTUALLY WORK.
          </h3>
          <p className="text-lg md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed mb-8" data-id="element-87">
            Most junk companies just haul. They show up with a truck, load it,
            and leave. But what about the concrete slab you need broken up
            first? The shed that needs to come down? The dirt, the green waste,
            the old fence, the piano that nobody can lift?
          </p>
          <p className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wider" data-id="element-88">
            A truck and two guys can't solve a problem like that.{' '}
            <br className="hidden md:block" data-id="element-89" />
            <span className="text-[#C8102E]" data-id="element-90">YOU NEED A CREW.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}